
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStkmedthodGrid extends Serenity.EntityGrid<IcStkmedthodRow, any> {
        protected getColumnsKey() { return IcStkmedthodColumns.columnsKey; }
        protected getDialogType() { return IcStkmedthodDialog; }
        protected getIdProperty() { return IcStkmedthodRow.idProperty; }
        protected getInsertPermission() { return IcStkmedthodRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStkmedthodRow.localTextPrefix; }
        protected getService() { return IcStkmedthodService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}